import { useEffect } from 'react';
import { useConfigValue } from '@/hooks/useSiteConfig';

interface PageTitleProps {
  title?: string;
}

export function PageTitle({ title }: PageTitleProps) {
  const appName = useConfigValue('appName');
  
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const prev = document.title;
    const fullTitle = title ? `${title} - ${appName}` : appName;
    if (fullTitle && fullTitle !== prev) document.title = fullTitle;
    return () => {
      document.title = prev;
    };
  }, [title, appName]);

  return null;
}